package com.platforma.chat_domain.use_case.message

import com.platforma.chat_domain.MessageStatus
import com.platforma.chat_domain.model.TableMessageDomain
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.transform
import team.platforma.chat_data.repository.messages.MokMessagesRepository
import kotlin.coroutines.coroutineContext

class TableMessageUseCase(
    private val mokMessagesRepository: MokMessagesRepository
) {
    fun observeMessages(aiModelId: Long?, chatId: Long): Flow<List<TableMessageDomain>> = mokMessagesRepository.observeMessages(aiModelId, chatId).transform { value ->
         val list = value.map { TableMessageDomain(it.textMessage , MessageStatus.valueOf(it.status), it.senderId) }
        return@transform emit(list)
    }

    suspend fun updateMessage(chatId: Long, tableMessageId: Long, status: MessageStatus) {
        mokMessagesRepository.updateMessage(chatId, tableMessageId, status.name)
    }
}